import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ClaimsUpload from "../../../components/Claims/ClaimsUpload";
import Spinner from "../../../components/SpringLoader/index";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { GET, newFetch, POST } from "../../../helpers/fetch";

const ClaimsAdd = ({ sites }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const activeSiteID = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const activeClientID = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const [claimTypes, setClaimTypes] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeSite, setActiveSite] = useState(null);
  const [activeSiteAssociate, setActiveSiteAssociate] = useState(null);
  const [totalClaims, setTotalClaims] = useState(0);
  const [totalDeductClaims, setTotalDeductClaims] = useState(0);
  const [totalSafetyShoesClaims, setTotalSafetyShoesClaims] = useState(0);
  const [claimBalance, setClaimBalance] = useState(0);
  const [safetyShoesClaimBalance, setSafetyShoesClaimBalance] = useState(0);
  const [claimNoOfReceipts, setClaimNoOfReceipts] = useState(0);
  const today = new Date();
  const monthYear = today.toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  const [claimMonth, setClaimMonth] = useState(null);
  const [claimYear, setClaimYear] = useState(null);
  const [selectedClaimType, setSelectedClaimType] = useState(null);

  const fetchAll = async () => {
    try {
      let api_pathClaims = `/associate/claims`;
      let claimsResponse = await newFetch(POST, api_pathClaims, {
        id: JSON.parse(localStorage.getItem("user")).id,
        claimMonth,
        claimYear,
      });

      if (claimsResponse.success) {
        setTotalClaims(claimsResponse.totalClaim);
        setTotalDeductClaims(claimsResponse.totalDeductClaim);
        setClaimNoOfReceipts(claimsResponse.totalClaimNoOfReceipts);
        setTotalSafetyShoesClaims(claimsResponse.totalSafetyShoesClaim);
        setLoading(false);
      } else {
        ToastUtil.error(claimsResponse.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaimTypes = async () => {
    try {
      let api_path = `/claimtypes/${activeSiteID}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let claimTypes = response.data;
        setClaimTypes(claimTypes);
        setLoading(false);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    fetchClaimTypes();
  }, []);

  useEffect(() => {
    fetchAll();
  }, [update]);

  useEffect(() => {
    if (activeSite?.enable_ss_claim_limit) {
      if (activeSiteAssociate?.ss_claim_limit) {
        setSafetyShoesClaimBalance(
          parseFloat(
            (
              parseFloat(activeSiteAssociate?.ss_claim_limit || 0) -
              parseFloat(totalSafetyShoesClaims)
            ).toFixed(2)
          )
        );
      }
    }

    if (activeSite?.enable_claim_limit) {
      if (activeSiteAssociate?.claim_limit) {
        if (activeSite?.enable_claim_percentage) {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalDeductClaims)
              ).toFixed(2)
            )
          );
        } else {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalClaims)
              ).toFixed(2)
            )
          );
        }
      }
    }
  }, [activeSite, activeSiteAssociate, totalClaims, totalSafetyShoesClaims]);

  useEffect(() => {
    if (sites.length > 0) {
      const filterSite = sites.find((item) => item.id === activeSiteID);
      setActiveSite(filterSite);
    }
  }, [sites]);

  useEffect(() => {
    const fetchUser = async () => {
      let api_path = "/associate/aboutme";
      let response = await newFetch(GET, api_path);

      if (response.success) {
        if (response.data?.site_associates) {
          const filterSiteAssociate = response.data?.site_associates.find(
            (item) => item.site_id === activeSiteID
          );
          setActiveSiteAssociate(filterSiteAssociate);
        }
      }
    };

    if (user) {
      fetchUser();
    }
  }, []);

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/claims">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Claims")}
        </h4>
        <div className="my-4"></div>
        <div className="accordion my-3 bg-white" id="accordionFAQs">
          {loading ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <ClaimsUpload
                claimTypes={claimTypes}
                updateState={updateState}
                claimBalance={claimBalance}
                claimNoOfReceipts={claimNoOfReceipts}
                activeSite={activeSite}
                activeSiteAssociate={activeSiteAssociate}
                monthYear={monthYear}
                setClaimMonth={setClaimMonth}
                claimMonth={claimMonth}
                setClaimYear={setClaimYear}
                claimYear={claimYear}
                setSelectedClaimType={setSelectedClaimType}
                selectedClaimType={selectedClaimType}
                safetyShoesClaimBalance={safetyShoesClaimBalance}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimsAdd;
